import { useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, Grid, Box } from "@mui/material";

import { useAxios } from "../../hooks";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    background: "transparent",
    width: "calc(100% - 15px)",
    margin: "15px",
  },
}));

const ContentBox = styled(Box)(({ theme }) => ({
  textAlign: "start",
  alignContent: "center",
  alignItems: "center",
  borderRadius: "12.5px",
  background: "rgb(255, 255, 255)",
  padding: "25px",
  width: "100%",
}));

const GenerateQRDialog = ({
  userImage,
  generateQRPopUp,
  setGenerateQRPopUp,
}) => {
  const axios = useAxios();
  const { visitorData } = useSelector((state) => state.memberDetails);

  const [QRImg, setQRImg] = useState("");

  useEffect(() => {
    if (userImage) {
      const userPayloadString = localStorage.getItem(
        Object.keys(localStorage).filter((item) => {
          return item.includes("userPayload");
        })[0]
      );
      const userPayload = JSON.parse(userPayloadString);

      axios({
        url: "/event/qr/generate-qr",
        method: "POST",
        data: {
          name: `${visitorData?.firstName ? visitorData?.firstName : ""} ${
            visitorData?.lastName ? visitorData?.lastName : ""
          }`,
          face_data: userImage,
          mobile_number: visitorData?.phoneNumber,
          visitor_id: visitorData?.ID,
          dob: userPayload?.dob,
          gender: visitorData?.gender,
        },
      }).then((response) => {
        if (response.status) {
          setQRImg(response.data);
        }
      });
    }
  }, [userImage]);

  return (
    <StyledDialog
      open={generateQRPopUp}
      onClose={() => setGenerateQRPopUp(false)}
      maxWidth="sm"
      fullWidth
    >
      <Grid container sx={{ background: "transparent", padding: "10px 0px" }}>
        <Grid item container justifyContent={"end"}>
          <CloseIcon
            sx={{
              fontSize: "35px",
              padding: "4px",
              color: "white",
              borderRadius: "50%",
              background: "#FFFFFF38",
            }}
            onClick={() => setGenerateQRPopUp(false)}
          />
        </Grid>
      </Grid>

      <DialogContent sx={{ padding: "5px 0px" }}>
        <ContentBox>
          <img style={{ width: "100%", height: "35vh" }} src={QRImg} />
        </ContentBox>
      </DialogContent>
    </StyledDialog>
  );
};

export default GenerateQRDialog;
